<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="holder">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <ValidationProvider
                    class="active-form__field"
                    name="holder-full_name"
                    rules="required|max:255"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="holder-full_name">ФИО</label>

                    <VInput
                        id="holder-full_name"
                        name="holder-full_name"
                        class="active-form__control"
                        placeholder="ФИО"
                        :class="{
                            error: errors[0],
                        }"
                        @submit="handleSubmit(submit)"
                        v-model="holder.full_name"
                    ></VInput>

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <ValidationProvider class="active-form__field" name="holder-type" rules="required" v-slot="{ errors }">
                    <label class="active-form__label active-form__label_required" for="holder-type">Вид</label>

                    <VSelect
                        id="holder-type"
                        name="holder-type"
                        label="label"
                        class="active-form__control control"
                        placeholder="Вид держателя"
                        :clearable="false"
                        :class="{
                            error: errors[0],
                        }"
                        :options="typeOptions"
                        :reduce="(type) => type.value"
                        v-model="holder.type"
                    />

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <ValidationProvider class="active-form__field" name="holder-comment" v-slot="{ errors }">
                    <label class="active-form__label" for="holder-comment">Комментарий</label>

                    <VInput
                        id="holder-comment"
                        name="holder-comment"
                        class="active-form__control"
                        placeholder="Например: подрядчик по ГПХ до конца года"
                        :class="{
                            error: errors[0],
                        }"
                        @submit="handleSubmit(submit)"
                        v-model="holder.comment"
                    ></VInput>

                    <span class="active-form__error">
                        {{ errors[0] }}
                    </span>
                </ValidationProvider>

                <!-- Гашение вместо удаления: запись остаётся ради истории предмета,
                     но погашенную больше не предлагаем к назначению. -->
                <!-- ГАШЕНИЕ ВМЕСТО УДАЛЕНИЯ. Запись справочника нужна истории предмета
                     и после ухода человека, поэтому удалить её нельзя нигде; погашенная
                     просто пропадает из выбора в карточке оборудования.

                     Занятого держателя погасить не дают: техника осталась бы закреплена
                     за тем, кого в справочнике как бы нет, и вернуть её стало бы некому.
                     Переключатель гаснет, а не молчит — рядом сказано, сколько единиц
                     мешает и что с ними сделать. Отказ всё равно за сервером
                     (InventoryHolderService::update). -->
                <div class="active-form__field" v-if="!insert">
                    <label class="active-form__label" for="holder-active">Активен</label>

                    <VSwitchButton
                        id="holder-active"
                        color="#00a55a"
                        :disabled="isHeld"
                        v-model="holder.active"
                    ></VSwitchButton>

                    <span class="active-form__hint" v-if="isHeld">
                        За держателем числится оборудование ({{ heldCount }}). Погасить запись можно после того, как
                        технику вернут или передадут другому держателю.
                    </span>
                </div>

                <div class="active-form__actions">
                    <VButton type="button" class="active-form__action button_green-light" @click="hide">
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green"> Сохранить </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VSelect from '../../../components/VSelect/VSelect.vue';
import VSwitchButton from '../../../components/VCheckbox/VSwitchButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import InventoryHolderTypeTitle from '../../../../js/enums/InventoryHolderTypeTitle';

@Component({
    components: {
        VInput,
        VButton,
        VSelect,
        VSwitchButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryHolderModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_HOLDER_CARD })
    name;
    @Prop({ type: String, default: 'Карточка держателя' })
    defaultTitle;

    holder = null;
    insert = false;

    typeOptions = Object.keys(InventoryHolderTypeTitle).map((value) => ({
        value: Number(value),
        label: InventoryHolderTypeTitle[value],
    }));

    /**
     * Сколько техники числится за держателем.
     *
     * Приходит со строкой списка (items_count, см. InventoryHoldersController::paginate).
     * Отсутствие ключа считаем нулём: форма открывается и из создания, где записи ещё нет.
     *
     * @returns {number}
     */
    get heldCount() {
        return Number(this.holder?.items_count ?? 0);
    }

    /**
     * Занят ли держатель. Занятого гасить нельзя — см. комментарий в шаблоне.
     *
     * @returns {boolean}
     */
    get isHeld() {
        return this.heldCount > 0;
    }

    submit() {
        this.resolve(this.holder);
        this.hide();
    }

    beforeOpen(event) {
        this.holder = event?.params?.holder;
        this.insert = event?.params?.insert ?? false;
    }

    beforeClose() {
        this.holder = null;
        this.insert = false;
    }
}

export default VInventoryHolderModal;
</script>
<style lang="scss">
// Пояснение под заблокированным переключателем. Не ошибка — красный здесь врал бы:
// пользователь ничего не сделал неверно, ему объясняют, почему действие недоступно.
.active-form__hint {
    display: block;
    margin-top: 6px;
    color: #5f6368;
    font-size: 0.8125rem;
    line-height: 1.15rem;
}
</style>
